import React from 'react';
import { observer } from 'mobx-react';
import { observable, toJS } from 'mobx';
import Spinner from "./Spinner";
import { wait } from '../libs/wait';

@observer
class FormMultiSelectInput extends React.Component {

  @observable openOptions = false;
  @observable filterText = '';
  @observable readyToClose = false;
  @observable scrollTop = 0;
  @observable showSelected = false;
  @observable divRef = null;
  @observable closing = false;

  componentDidMount() {
    window.addEventListener('mousedown', this.windowMouseDownListener);
    window.addEventListener('mouseup', this.windowMouseUpListener);

    let modalElement = document.getElementsByClassName('modalChildren');
    if (!!modalElement && !!modalElement.length) {
      modalElement[modalElement.length - 1].addEventListener('scroll', this.scrollListener);
      this.scrollTop = modalElement[modalElement.length - 1].scrollTop;
    }
  }

  componentWillUnmount() {
    window.removeEventListener('mousedown', this.windowMouseDownListener);
    window.removeEventListener('mouseup', this.windowMouseUpListener);

    let modalElement = document.getElementsByClassName('modalChildren')[0];
    if (!!modalElement && !!modalElement.length) modalElement[modalElement.length - 1].removeEventListener('scroll', this.scrollListener);
  }

  windowMouseDownListener = e => {
    let { id, label } = this.props;
    const element = document.getElementById(id || label)

    if (!!element && !this.divRef.contains(e.target) && this.openOptions) {
      this.readyToClose = true;
    }
  };

  windowMouseUpListener = () => {
    if (this.readyToClose) {
      this.toggleOptionOpen();
      this.readyToClose = false;
    }
  };

  scrollListener = (e) => {
    this.scrollTop = e.target.scrollTop;
  }

  onChangeFilterText = e => this.filterText = e.target.value;
  toggleOptionOpen = async () => {
    if (this.openOptions) {
      this.closing = true;
      await wait(80)
      this.closing = false;
    }
    this.openOptions = !this.openOptions;
    this.showSelected = false;
    this.filterText = ''
  };

  optionsChangeAll = (value, optionClicked) => {
    const { filterOptions, optionsChangeAll } = this.props;
    if (optionsChangeAll) {
      let newOptions = Object.assign([], toJS(this.props.options)).map(item => {
        if (this.filterText === '' ||
          (!filterOptions ? item.label.toLowerCase().indexOf(this.filterText.toLowerCase()) === 0 : !!filterOptions([item], this.filterText).length)) {
          item.value = value
        }
        return toJS(item);
      })
      this.props.optionsChangeAll(newOptions);
      // this.props.optionsChangeAll(value, this.filterText);
    } else {
      this.getFilteredOptions(this.props.options).forEach(item => {
        item.value = !value;
        optionClicked(item);
      });
    }
  }

  getFilteredOptions = options => {
    if (this.filterText === '') return options;
    const { filterOptions } = this.props;
    if (!filterOptions) return options.filter(item => item.label.toLowerCase().indexOf(this.filterText.toLowerCase()) === 0);
    return filterOptions(options, this.filterText.toLowerCase())
  };

  __sortData = (data, sortBy) => {
    return data.sort((a, b) => a[sortBy || "label"].localeCompare(b[sortBy || 'label'], undefined, { numeric: true }))

    // old sort type
    // return data.sort((a, b) => (a[sortBy || 'label'] || '').toLowerCase().trim() > (b[sortBy || 'label'] || '').toLowerCase().trim() ? 1 : -1)
  }

  _renderOptions = (options) => {
    const { label, id, optionClicked, isLoading, hideClearAll, hideSelectAll, optionsChangeAll } = this.props;
    return (
      <div className={`multi-select-options ${this.closing ? 'multi-select-options-closing' : ''}`} style={{ transform: `translateY(${4 - this.scrollTop}px)` }}>
        <div className='options-controller'>
          <input type='text' placeholder={`Search ${label}`} onChange={this.onChangeFilterText} style={{ minWidth: '150px' }} autoFocus />
          {!hideSelectAll && <i className='button fa fa-check white' onClick={() => this.optionsChangeAll(true, optionClicked, optionsChangeAll)} data-toogle="tooltip" title="Select All" />}
          {!hideClearAll && <i className='button fa fa-close white' onClick={() => this.optionsChangeAll(false, optionClicked, optionsChangeAll)} data-toogle="tooltip" title="Clear All" />}
          <i className={`button fa fa-eye${this.showSelected ? '' : '-slash'} white`} onClick={() => this.showSelected = !this.showSelected} data-toogle="tooltip" title="Show Selected" />
        </div>
        {isLoading ? <Spinner /> :
          <ul>{(this.showSelected ? options.filter(item => item.value) : options).map(item => {
            return (
              <li key={`${id}-option-${item.id}`} value={item.id} onClick={() => optionClicked(item)} data-toggle='tooltip' title={item.id}>
                <i className={item.value === true ? 'fa fa-check-square' : 'fa fa-square'} style={{ color: 'grey' }} />
                {item.label}
              </li>
            )
          })}</ul>}
      </div>
    );
  };

  render() {
    const { id, label, options, sortBy, isLoading } = this.props;

    return (
      <div className={`formInput flex flex-row`}>
        {label && label !== '' && <label className='flex flex-column justify-center'>{label}</label>}
        <div ref={(ref) => this.divRef = ref} id={id} className='formInputMulti'>
          <div className={`multi-select-input lightBg`} onClick={this.toggleOptionOpen}>
            <div>{isLoading ? 'Loading...' : !!options && !!options.length ? `${options.filter(item => item.value === true).length} selected of ${options.length}` : ''}</div>
            <i className='fa fa-caret-down' />
          </div>
          {this.openOptions && this._renderOptions(this.__sortData(this.getFilteredOptions(options), sortBy))}
        </div>
      </div>
    );
  }
}

export default FormMultiSelectInput;



// WEBPACK FOOTER //
// ./src/components/FormMultiSelectInput.js